import { UIChart } from '../chart/ui-chart';
import { Component } from '../../../shared-components/decorators/component.decorator';
import type { XAxisOptions, Options, NavigatorXAxisOptions } from 'highcharts';
import styles from './ui-chart-stock.css';

/**
 * @class
 * @memberof ChartsComponents
 * @element ui-chart-stock
 * @augments {UIChart}
 * @alias UIChartStock
 * @classdesc Represents a class for <code>ui-chart-line</code> element.
 * Draws line type chart.
 * @example
 * <ui-chart-line></ui-chart-line>
 */
@Component({ tag: 'ui-chart-stock', styles })
export class UIChartStock extends UIChart {
    override get type(): string {
        return 'line';
    }

    override get stock(): boolean {
        return true;
    }

    protected override resolvePresets(): boolean {
        this.setOptions(UIChart.presets.interactive);
        return true;
    }

    /**
     * Returns shared date/time axis label configuration.
     * @private
     */
    private getDateAxisLabelConfig<T = XAxisOptions>(): T {
        return {
            labels: {
                format: '{value:%e %b}',
            },
            dateTimeLabelFormats: {
                day: '%e %b',
                week: '%e %b',
                month: '%e %b %Y',
                year: '%Y',
            },
        } as T;
    }

    private get chartConfig(): Options {
        return {
            legend: {
                enabled: false,
            },
            xAxis: {
                visible: true,
                ...this.getDateAxisLabelConfig<XAxisOptions>(),
            },
            yAxis: {
                visible: true,
            },
            plotOptions: {
                series: {
                    marker: {
                        enabled: false,
                        radius: 0,
                        states: {
                            hover: {
                                enabled: true,
                                radius: 4,
                            },
                        },
                    },
                },
            },
            navigator: {
                series: {
                    marker: {
                        enabled: false,
                    },
                },
                xAxis: {
                    ...this.getDateAxisLabelConfig<NavigatorXAxisOptions>(),
                },
            },
            responsive: {
                rules: [
                    {
                        condition: {
                            maxWidth: 767,
                        },
                        chartOptions: {
                            rangeSelector: {
                                inputPosition: {
                                    align: 'left',
                                },
                            },
                        },
                    },
                ],
            },
            rangeSelector: {
                inputDateFormat: '%d %b %Y',
            },
        };
    }

    /**
     * @inheritDoc
     */
    override renderChart(): void {
        this.draw(this.chartConfig);
    }
}
